import { SignInData } from ".";
import SignInForm from "./signInPages/signInForm";
import SignInMethod from "./signInPages/signInMethod";
import ForgotPassword from "./signInPages/forgotPassword";

export interface SignInPageItem {
  pageName: string;
  component: (
    signInData: SignInData,
    setSignInData: React.Dispatch<React.SetStateAction<SignInData>>,
  ) => JSX.Element;
}

export const SignInPages: SignInPageItem[] = [
  {
    pageName: "signInMethod",
    component: (signInData, setSignInData) => <SignInMethod />,
  },
  {
    pageName: "signInForm",
    component: (signInData, setSignInData) => (
      <SignInForm signInData={signInData} setSignInData={setSignInData} />
    ),
  },
  {
    pageName: "forgotPassword",
    component: (signInData, setSignInData) => (
      <ForgotPassword signInData={signInData} setSignInData={setSignInData} />
    ),
  },
];
